import { TabStyles } from '@tableau/widgets';

import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

export const button: React.CSSProperties = {
	padding: `0 ${TabStyles.Spacing.SmallSpace}px`,
	height: 24,
	width: 174,
	marginRight: 40,
};

export const dropdown: React.CSSProperties = {
	height: 14,
	width: 124,
	paddingLeft: '1px',
};

export const chevron: React.CSSProperties = {
	...PageHeaderStyles.iconForTextButton,
	paddingLeft: '2px',
};


export const dropdownContainer: React.CSSProperties = {
	display: 'flex',
	flexDirection: 'column',
	paddingBottom: '8px',
	justifyContent: 'space-between',
};

export const textField: React.CSSProperties = {
    alignItems: 'left',
    width: 462,
    height: 234,
};
